export const endPoints = {
    user: `/users`,
    configurator: `/configuration`,
    groupvalues: `/configuration/group-values`,
    valueslist: `/configuration/values-list`,
    fieldDefinition: `/configuration/field-definition`,
    file: `/file`,
    activityLogs: '/activity/list',
    productLicense: '/productLicense',
    entitlement: '/entitlement',
    voucher: '/voucher',
    feature: '/entitlement/feature',
    license: '/entitlement/product',
    voucherOverview: '/entitlement/voucher-overview',
    languageCodes: '/language-codes',
    productRoles: '/productroles',
    authorization: '/authorization',
};

let backendHost;
let filterApi;

const hostname = window && window.location && window.location.hostname;


const localhost = 'localhost';
const dev = 'd.digitalactivation.grundfos.dev';
const test = 't.digitalactivation.grundfos.dev';
const qual = 'q.digitalactivation.grundfos.dev';
const ort = 'gf-web-fwstoreadmin-o-azwe.azurewebsites.net';
const prod = 'digitalactivation.grundfos.com';

if (hostname === localhost) {
    backendHost = 'https://d.api.adminapi.digitalactivation.grundfos.dev';
    // backendHost = 'https://localhost:44348';
    filterApi = 'https://gf-fn-familytypeversion-d-azwe.azurewebsites.net/api/units?code=2afXWTxL/8EnagS2Oo2gbtu001qrIoJB0dpySSy/SB2zdcVM6FA1EA==';
} else if (hostname === dev) {
    backendHost = 'https://d.api.adminapi.digitalactivation.grundfos.dev';
    filterApi = 'https://gf-fn-familytypeversion-d-azwe.azurewebsites.net/api/units?code=2afXWTxL/8EnagS2Oo2gbtu001qrIoJB0dpySSy/SB2zdcVM6FA1EA==';
} else if (hostname === test) {
    backendHost = 'https://t.api.adminapi.digitalactivation.grundfos.dev';
    filterApi = 'https://gf-fn-familytypeversion-t-azwe.azurewebsites.net/api/units?code=1uid748IKwp3iC3YlnFVB2Qbba8YTR1bFFFKwamGjxqDrsL4JSHxYg==';
} else if (hostname === qual) {
    backendHost = 'https://q.api.adminapi.digitalactivation.grundfos.dev';
    filterApi = 'https://gf-fn-familytypeversion-q-azwe.azurewebsites.net/api/units?code=66e57t318teqWZeDaa3gyk/0ueMsJH3rpnNuyhlg9hhrwI5HLZdpoQ==';
} else if (hostname === ort) {
    backendHost = 'https://gf-web-fwstoreadminapi-o-azwe.azurewebsites.net';
    filterApi = 'https://gf-fn-familytypeversion-q-azwe.azurewebsites.net/api/units?code=66e57t318teqWZeDaa3gyk/0ueMsJH3rpnNuyhlg9hhrwI5HLZdpoQ==';
} else if (hostname === prod) {
    backendHost = 'https://api.adminapi.digitalactivation.grundfos.com';
    filterApi = 'https://gf-fn-familytypeversion-p-azwe.azurewebsites.net/api/units?code=ORB6wKi0sE6GTxpj5aekHR0jXmUp2RI33ji0hE6zl1qPgvqXKV/93A==';
} else {
    backendHost = process.env.REACT_APP_BACKEND_HOST || 'https://d.api.adminapi.digitalactivation.grundfos.dev';
    filterApi = 'https://gf-fn-familytypeversion-d-azwe.azurewebsites.net/api/units?code=g76VJo4UqPuBlV5evJonzqyJzOB8Q/PKgtKKHOrI/cnXXna9LQYUSQ==';
}

export const API_ROOT = `${backendHost}/api/v1`;
export const API_ROOT_V2 = `${backendHost}/api/v2`;
export const FILTER_API = filterApi;